import { render, staticRenderFns } from "./packageTypeColumnMenu.vue?vue&type=template&id=c00f806a&"
import script from "./packageTypeColumnMenu.vue?vue&type=script&lang=js&"
export * from "./packageTypeColumnMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports